<div class="machines-container">
  <div class="total-number">
    {{ 'VALUE Machines' | translate: { value: machinesService.state.total } }}
  </div>
  <rotec-default-grid-v2
    [darkMode]="true"
    [filterButton]="false"
    [searchInput]="true"
    [selectConfig]="{ checkboxAlwaysVisible: true, checkboxToggleOnWholeRow: true }"
    [columns]="machinesService.columns"
    [data]="machinesService.state$ | async"
    [selectedResults]="machinesService.selectedIds$ | async"
    (stateChange)="machinesService.search($event)"
    (fulltextSearchChanged)="search($event, 'machines')"
    (selectedResultsChange)="selectedResultsChange('machines', $event)"
  >
    <ng-template rotecGridCellV2="name" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.name }}</p>
    </ng-template>
    <ng-template rotecGridCellV2="serial" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.serial }}</p>
    </ng-template>
    <ng-template rotecGridCellV2="_groups" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.groups }}</p>
    </ng-template>
    <ng-template rotecGridCellV2="manufacturer" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.manufacturer }}</p>
    </ng-template>
    <ng-template rotecGridCellV2="plant" let-dataItem="dataItem">
      <p class="grid-text-cell">{{ dataItem.plant }}</p>
    </ng-template></rotec-default-grid-v2
  >
</div>
